import type {
  CartCountResponse,
  UpdateSessionLocalFiltersRequest,
  UpdateSessionLocalFiltersResponse,
} from '@weberus/shared-types';

import { fetcher } from '@/app/_shared/utils/fetcher';

/**
 * 유저 cart count 조회
 */
export const fetchUserCartCount = async (headers?: Headers) => {
  return fetcher<CartCountResponse>({
    url: '/journey/cart/count',
    method: 'GET',
    headers,
  });
};

/* 국내숙소 체크인/체크아웃 날짜 및 인원 필터 정보 업데이트 */
export const updateSessionLocalFilters = async (args: UpdateSessionLocalFiltersRequest) => {
  return fetcher<UpdateSessionLocalFiltersResponse, UpdateSessionLocalFiltersRequest>({
    method: 'POST',
    url: `/fe-session/local-filters`,
    data: args,
  });
};
